import { Box, Typography } from "@mui/material";
import React from "react";

export default function ProjectNotFound() {

    return(
        <Box>
            <Typography variant="h3">Project Not Found</Typography>
        </Box>
    )
}